import { render } from "./CarouselSociedad.vue?vue&type=template&id=d4b73272"
import script from "./CarouselSociedad.vue?vue&type=script&lang=js"
export * from "./CarouselSociedad.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Proyectos\\puerto-antioquia-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__